import {availableStates} from '@/helpers/availableStates'

export default function() {
    return {
        availableStates,
        currentTab: 0,
        agency: {
            name: '',
            picture: '',
            pictureBase64: '',
            cover: '',
            about: '',
            description: '',
            cart: false,
            recebeAquiToken: '',
            cnpj: '',
            cadastur: '',
            mail: '',
            fbPageId: '',
            phone: '',
            password: '',
            city: '',
            state: '',
            pagarmeId: '',
            split: false,
            useNativeSplit: false,
        },
        isEditing: false,
        errors: {
            name: null,
            picture: null,
            cover: null,
            about: null,
            description: null,
            cart: null,
            recebeAquiToken: null,
            cnpj: null,
            cadastur: null,
            mail: null,
            fbPageId: null,
            phone: null,
            password: null,
            split: null,
            useNativeSplit: null,
        },
        croppingImage: null,
        showCropper: false,
        croppingModel: null,
        error: false,
        success: false,
        customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
    }
}
